export default [
  'fetchPreferences',
]


// WEBPACK FOOTER //
// ./src/store/preferences/types.js